<script>
  import { Link } from 'svelte-navigator';
  import Button from '../components/Button.svelte';
  import NavBar from '../components/NavBar.svelte';
  import { onMount } from 'svelte';
  import Fer from '../Fer.js';

  import Slider from '@bulatdashiev/svelte-slider';

  const shuffle = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };
  const people = shuffle([
    {
      name: "Adam Lenzinger",
      title: "Designer",
      url: "https://www.linkedin.com/in/adamlenzinger/",
    },
    {
      name: "Ghofrane Ben Hmaid",
      title: "Font-end developer",
      url: "https://www.linkedin.com/in/ghofranebenhmaid/",
    },
    {
      name: "Rasmus Jones",
      title: "ML engineer",
      url: "https://www.linkedin.com/in/rasmus-jones-b4552480/",
    },
  ]);

  let fer, videoInput, cam;
  let neutral,
    smile,
    surprise,
    disgust,
    anger = [0.0, 100.0];

  let pump_elem, pump_anim, animApi;

  let pumpsliderValue = [0, 100];
  let pumpslider = pumpsliderValue[0];

  let bucketsliderValue = [0, 100];
  let bucketslider = bucketsliderValue[0];

  let flowsliderValue = [0, 100];
  let flowslider = bucketsliderValue[0];

  let every_x_frame = 2;
  let framerate_count = 0;

  const updatePumpslider = (e) => {
    pumpslider = e.detail[0];
  };
  const updateBucketSlider = (e) => {
    bucketslider = e.detail[0];
  };
  const updateFlowSlider = (e) => {
    flowslider = e.detail[0];
  };

  function animloaded() {
    animApi = lottie_api.createAnimationApi(pump_anim);
    let pump = animApi.getKeyPath('PumpSlider,Transform,X Position');
    let bucket = animApi.getKeyPath('BucketSlider,Transform,X Position');
    let stream = animApi.getKeyPath('StreamSlider,Transform,X Position');
    animApi.addValueCallback(pump, function (currentValue) {
      return pumpslider;
    });
    animApi.addValueCallback(bucket, function (currentValue) {
      return bucketslider;
    });
    animApi.addValueCallback(stream, function (currentValue) {
      return flowslider;
    });
  }

  onMount(() => {
    cam = new Camera(videoInput, {
      facingMode: 'user',
      width: 1280,
      height: 720,
      onFrame: async () => {
        if (framerate_count % every_x_frame == 0) {
          const logits = await fer.getLogits(videoInput, 1280, 720);
          // console.log(logits)
          if (logits !== undefined) {
            // neutral = [100*logits[0], 100.0];
            // smile = [100*logits[1], 100.0];
            // surprise = [100*logits[2], 100.0];
            // disgust = [100*(logits[3]+logits[4]), 100.0];
            // anger = [100*logits[5], 100.0];

            // ['surprise','disgust','smile','anger','neutral']
            surprise = [100 * logits[0], 100.0];
            disgust = [100 * logits[1], 100.0];
            smile = [100 * logits[2], 100.0];
            anger = [100 * logits[3], 100.0];
            neutral = [100 * logits[4], 100.0];
          }
        }
        framerate_count += 1;
      },
    });
    pump_anim = lottie.loadAnimation({
      container: pump_elem,
      path: '/lotties/pump.json',
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });

    pump_anim.addEventListener('DOMLoaded', animloaded);
  });

  const startCamera = () => {
    fer = Fer.getInstance();
    fer.setupTf().then(() => {
      cam.start();
    });
  };

  const stopCamera = () => {
    cam.stop();
  };
</script>

<section class="about">
  <NavBar />
  <div class="about__top">
    <h4 class="about__title">ABOUT</h4>
    <p>
      Face Garden combines machine learning and motion graphics to create three small
      games that react to facial expressions. Complete tasks in the garden by exercising some
      of the 43 muscles in your face. This research project investigates new types of digital
      interactions that could provide playful alternatives to conventional modes of physical
      therapy. The project explores a variety of interactions between input and output signals. The
      input signals are a series of 5 facial expressions detected via webcam. The output signals
      are a series of animated garden objects, which provide real-time visual feedback for your
      facial movements.
    </p>
  </div>
  <!--  -->
  <div class="about__description">
    <h4 class="about__title">INPUT: FACIAL EXPRESSIONS</h4>
    <p>
      The games use your webcam and machine learning to detect 5 facial expressions;
      'NEUTRAL', 'SMILE', 'SURPRISE', 'DISGUST', and 'ANGER'. The facial expression recognition
      model is trained using the CMU Multi-PIE dataset, which contains more than 750,000
      images of 337 people recorded in up to four sessions over the span of five months.
      Subjects were imaged under 15 view points and 19 illumination conditions while
      displaying a range of facial expressions. Although the dataset contains a large amount of
      images with a high degree of diversity, the detection might not always be accurate. Make
      sure that there are good lighting conditions and that your face is clearly visible. Play
      around with the example below to see if you can make the kind of faces that the game is
      looking for.
    </p>
  </div>
  <!--  -->
  <figure class="about__image">
    <div class="flex-container flex flex-ai-c flex-jc-c">
      <div class="flex-child slider">
        Neutral: <br />
        <Slider bind:neutral value={neutral} />
        Smile: <br />
        <Slider bind:smile value={smile} />
        Surprise: <br />
        <Slider bind:surprise value={surprise} />
        Disgust: <br />
        <Slider bind:disgust value={disgust} />
        Anger: <br />
        <Slider bind:anger value={anger} />
      </div>
      <div class="flex-child">
        <video
          class="camera"
          style="transform: scaleX(-1);"
          bind:this={videoInput}
        >
          <track kind="captions" srclang="en" label="english_captions" />
        </video>
        <div class="home__hero--btn">
          <Button
            on:click={startCamera}
            buttonSize="btn--small"
            buttonStyle="btn--primary--solid"
          >
            START CAMERA
          </Button>
          <Button
            on:click={stopCamera}
            buttonSize="btn--small"
            buttonStyle="btn--primary--solid"
          >
            STOP CAMERA
          </Button>
        </div>
      </div>
    </div>
  </figure>  
  
  <div class="about__description">
    <h4 class="about__title">OUTPUT: SVG ANIMATIONS</h4>
    <p>
      The output signals are various animated garden objects, which provide real-time visual
      feedback to your facial movements. The animations are created using Adobe After Effects
      and two plug-ins called 'Bodymovin' and 'Joysticks and Sliders'. 'Bodymovin' allows SVG
      layers to be exported as a lightweight vector-based animation called 'Lottie'. 'Joysticks
      and Sliders' allows for multiple axes to be contained in a single animation. For example,
      the water pump below has three parameters that can be animated independently: 1) the
      position of the pump handle 2) the amount of water in the bucket, and 3) the water
      flowing from the pump. Use the sliders below to animate the water pump.
    </p>
  </div>

  <figure class="about__image">
    <div class="flex-container flex flex-ai-c flex-jc-c ">
      <div class="flex-child slider">
        Handle: <br />
        <Slider bind:pumpsliderValue on:input={updatePumpslider} />
        Bucket: <br />
        <Slider bind:bucketsliderValue on:input={updateBucketSlider} />
        Flowing: <br />
        <Slider bind:flowsliderValue on:input={updateFlowSlider} />
        <!-- <label>
          <input type="checkbox" on:change={updateFlow} /> Flowing
        </label> -->
      </div>
      <div class="flex-child" bind:this={pump_elem} />
    </div>
  </figure>

  <div class="about__description">
    <h4 class="about__title">GAMES</h4>
    <p>
      The Face Garden project contains three small games; 'BLOOM', 'SAW', and 'PUMP'. Each
      game presents a simple task that you need to complete by making the corresponding
      facial expressions. The garden theme was selected as a metaphor for growth to align with
      the motivations for physical therapy. The games have no failure states — they are simply
      intended to be visual experiences that give your facial muscles a little workout.
    </p>
  </div>

  <div class="about__description">
    <h4 class="about__title_s">GAME 1: BLOOM</h4>
    <h4 class="about__title_s_black">TASK: Make 10 Flowers Bloom</h4>
    <p>
      A flowerpot is displayed on the screen. By making the displayed facial expression, the
      flower will begin to grow. Once the flower has fully bloomed, a new flowerpot is displayed
      on the screen. The task is complete once 10 flowers have bloomed.
    </p>
  </div>

  <figure class="about__image">
    <div class="flex-container flex flex-ai-c flex-jc-c ">
      <img src="assets/images/bloom_screenshot.png" alt="Bloom Game" />
    </div>
  </figure>

  <div class="about__description">
    <h4 class="about__title_s">GAME 2: SAW</h4>
    <h4 class="about__title_s_black">TASK: Saw 6 logs</h4>
    <p>
      A log and a saw are displayed on the screen. By making the displayed facial expressions,
      the saw will cut through the log. 'SMILE' will saw in a forward motion, and 'ANGER' will saw
      in a backward motion. The task is complete when 6 logs have been cut.
    </p>
  </div>

  <figure class="about__image">
    <div class="flex-container flex flex-ai-c flex-jc-c ">
      <img src="assets/images/saw_screenshot.png" alt="Saw Game" />
    </div>
  </figure>

  <div class="about__description">
    <h4 class="about__title_s">GAME 3: PUMP</h4>
    <h4 class="about__title_s_black">TASK: Pump Water and make the garden grow.</h4>
    <p>
      A water pump and empty bucket are displayed on the screen. By making the displayed
      facial expressions, the pump will fill the bucket with water, which can then be used to
      water the garden. 'SMILE' will move the pump handle up, 'DISGUST' will move the
      pump handle down. If there is water in the bucket, 'SURPRISE' will make the garden grow. The
      task is complete when the garden is finished growing.
    </p>
  </div>

  <figure class="about__image">
    <div class="flex-container flex flex-ai-c flex-jc-c ">
      <img src="assets/images/pump_screenshot.png" alt="Pump Game" />
    </div>
  </figure>

  <div class="about__description about__mt80">
    <p>
      Face Garden demonstrates novel interactions between facial expressions and visual
      stimuli. The project is a proof of concept for types of digital interactions that can be
      used to stimulate muscular movements. In collaboration with medical experts, this
      concept could be further developed to create digital experiences that supplement or
      substitute some forms of physical therapy. This research project targets 5 common facial
      expressions, however, the same principles could also be applied to other input signals,
      such as hand movements, body posture, or more specific movements that align with
      relevant physical exercises. Similarly, the output signals could potentially be any type of
      visual stimuli that can be animated. Face Garden was designed and developed at the
      <a class="about__link" target="_blank" href="https://royaldanishacademy.com/centre-visibility-design">
      Royal Danish Academy, Centre for Visibility Design</a>, 
      as part of ongoing research into new forms of interactive physical therapy.
    </p>
  </div>

  <div class="about__description">
    <p>
      _ _ _
    </p>
    <p>
      FACE GARDEN (2022)
      <br />
      {#each people as person}
        {person.title}:
        <a class="about__link" target="_blank" href="{person.url}">{person.name}</a>
        <br />
      {/each}
      Supervisor:
      <a class="about__link" target="_blank" href="https://kglakademi.dk/employee/sofie-beier">Sofie Beier</a>
      <br />
      by <a class="about__link" target="_blank" href="https://royaldanishacademy.com/centre-visibility-design">
        Royal Danish Academy, Centre for Visibility Design
      </a>
    </p>
  </div>

  <div class="about__bottom">
    <div class="btn-content">
      <Link to="/games">
        <Button buttonSize="btn--xlarge" buttonStyle="btn--primary--solid">
          PLAY
        </Button>
      </Link>
    </div>
  </div>

</section>

<style>
  .slider {
    --progress-bg: #90b84b;
    --track-bg: #90b84b;
    --thumb-bg: #32793a;
  }

  .flex-container {
    display: flex;
  }

  .flex-child {
    flex: 1;
  }

  .flex-child:first-child {
    margin-right: 20px;
  }
</style>
